// extracted by mini-css-extract-plugin
export default {"arrow":"_f934c381","isLeft":"_ab12ad19"};